import i18n from "../i18n";
import { useToast as useVueToast } from "vue-toastification";

const { t } = i18n.global;

const toast = {
  error: (message: string, interpolateParams?: Record<string, unknown>): void =>
    void useVueToast().error(t(message, interpolateParams as any)),
  success: (
    message: string,
    interpolateParams?: Record<string, unknown>
  ): void => void useVueToast().success(t(message, interpolateParams as any)),
};

export const useToast = (): typeof toast => toast;
